/**
 * Zeprado: probki kolorow na kafelkach produktow.
 *
 * Zadanie skryptu: najechanie na kropke koloru podmienia zdjecie kafelka na zdjecie
 * tego produktu. Klikniecie dziala bez JS (zwykly <a href>), wiec brak skryptu
 * nie psuje nawigacji.
 *
 * Zasady:
 * - zdjecie pokazujemy dopiero po jego wczytaniu (zero migania i pustej ramki),
 * - warstwa podmiany jest position:absolute wewnatrz .card-gallery (zero skakania layoutu),
 * - na ekranach dotykowych podmiana jest wylaczona - kropka po prostu prowadzi do produktu,
 * - snippet moze doladowac ten plik wiecej niz raz (np. po odswiezeniu sekcji
 *   przez Section Rendering API) - straznik ponizej pilnuje jednej inicjalizacji.
 */
(function () {
  'use strict';

  if (window.__zpKoloryInit) return;
  window.__zpKoloryInit = true;

  var HOVER = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var KLASA = 'is-podglad';
  var KLASA_GALERIA = 'zp-kolory-aktywny';
  var aktywny = null;
  var token = 0;
  var wczytane = Object.create(null);

  function galeria(komp) {
    return komp.closest ? komp.closest('.card-gallery') : null;
  }

  function schowaj() {
    if (!aktywny) return;
    aktywny.classList.remove(KLASA);
    var g = galeria(aktywny);
    if (g) g.classList.remove(KLASA_GALERIA);
    aktywny = null;
  }

  function pokaz(komp, img, url) {
    if (aktywny && aktywny !== komp) schowaj();
    img.src = url;
    img.setAttribute('data-zp-url', url);
    komp.classList.add(KLASA);
    var g = galeria(komp);
    if (g) g.classList.add(KLASA_GALERIA);
    aktywny = komp;
  }

  function podglad(komp, probka) {
    var img = komp.querySelector('[data-zp-swap]');
    var url = probka.getAttribute('data-zp-img');
    if (!img || !url) {
      schowaj();
      return;
    }
    // aktualnie widoczne juz to zdjecie
    if (img.getAttribute('data-zp-url') === url && komp.classList.contains(KLASA)) return;

    if (wczytane[url]) {
      pokaz(komp, img, url);
      return;
    }

    var moj = ++token;
    var pre = new Image();
    pre.decoding = 'async';
    pre.onload = function () {
      wczytane[url] = true;
      // uzytkownik w miedzyczasie zjechal kursorem albo wybral inna kropke
      if (moj !== token) return;
      pokaz(komp, img, url);
    };
    pre.onerror = function () {
      if (moj === token) schowaj();
    };
    pre.src = url;
  }

  function przedwczesneWczytanie(lista) {
    var probki = lista.querySelectorAll('[data-zp-img]');
    for (var i = 0; i < probki.length; i++) {
      var url = probki[i].getAttribute('data-zp-img');
      if (!url || wczytane[url]) continue;
      wczytane[url] = true;
      var pre = new Image();
      pre.decoding = 'async';
      pre.src = url;
    }
  }

  function obsluz(cel) {
    if (!cel || !cel.closest) {
      schowaj();
      return;
    }
    var probka = cel.closest('[data-zp-probka]');
    var komp = cel.closest('[data-zp-kolory]');

    if (komp && !probka) {
      var lista = cel.closest('.zp-kolory__lista');
      if (lista) przedwczesneWczytanie(lista);
    }

    if (!probka || !komp || !komp.classList.contains('zp-kolory--karta')) {
      schowaj();
      return;
    }
    przedwczesneWczytanie(komp);
    podglad(komp, probka);
  }

  if (HOVER) {
    document.addEventListener('pointerover', function (e) {
      if (e.pointerType === 'touch') return;
      obsluz(e.target);
    }, { passive: true });

    document.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') schowaj();
    }, { passive: true });

    window.addEventListener('blur', schowaj);
    document.addEventListener('scrollend', schowaj, { passive: true });
  }

  // klawiatura: tabulacja po kropkach tez podmienia zdjecie
  document.addEventListener('focusin', function (e) {
    obsluz(e.target);
  });
  document.addEventListener('focusout', function (e) {
    var idzie = e.relatedTarget;
    if (!aktywny) return;
    if (idzie && aktywny.contains(idzie)) return;
    schowaj();
  });
})();
